<template>
    <div class="faq">
        <div class="faq__title">
            {{ $t('auth.faq.additional_info') }}
        </div>
        <div class="faq__subtitle">
            {{ $t('auth.faq.additional_info_subtext') }}
        </div>
        <nav class="faq-list">
            <router-link v-for="(link, idx) in faqs"
                         active-class="is-active"
                         class="faq-list__link"
                         :key="idx"
                         :to="link.href">
                {{$t(link.title)}}
            </router-link>
        </nav>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                faqs: [
                    {
                        title: 'auth.faq.impressum_title',
                        href: 'https://www.aciso.com/impressum'
                    },
                    {
                        title: 'auth.faq.data_protection_title',
                        href: 'https://www.aciso.com/datenschutz'
                    }
                ]
            }
        },
    }
</script>
<style lang="sass">
    .faq
        +reg
        &__title
            font-size: 16px
            color: $color--dark
            position: relative
            padding-left: 24px
            line-height: 22px
            &:before
                content: ''
                z-index: 1
                display: block
                position: absolute
                top: 50%
                left: 0
                transform: translateY(-50%)
                background-image: url('~@/assets/img/faqs/info.svg')
                background-size: contain
                background-repeat: no-repeat
                background-position: 50% 50%
                width: 14px
                height: 14px
        &__subtitle
            font-size: 12px
            color: rgba($color--dark, 0.5)
            margin: 9px 0 4px 0
    .faq-list
        &__link
            color: $color--blue
            font-size: 12px
            +reg
            text-decoration: none
            position: relative
            +tr(color .3s ease)
            &:not(:first-of-type)
                margin-left: 20px
            &:hover
                color: #023CDE
</style>